import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ViewTransitionService {
  private _finished: Promise<void> = Promise.resolve();

  notify(transition: ViewTransition): void {
    this._finished = transition.finished.catch(() => {});
  }

  get finished(): Promise<void> {
    return this._finished;
  }
}
